import Cookies from 'js-cookie';
import { createBehavior } from '@area17/a17-behaviors';

const YES_VALUE = 'yes';
const COOKIE_KEY = 'cookienotice:remember';

const cookienotice = createBehavior(
  'cookienotice',
  {
    remember() {
      Cookies.set(COOKIE_KEY, YES_VALUE, { expires: 30 });
    },
    open() {
      this.$node.classList.add('cookienotice:is-open');
    },
    close() {
      this.remember();
      this.$node.classList.remove('cookienotice:is-open');
      this.$node.inert = true;
    },
    onCloseBtnClick(evt) {
      evt.preventDefault();
      this.close();
    },
  },
  {
    init() {
      this.$closeBtn = this.getChild('close-btn');
      this.$closeBtn.addEventListener('click', this.onCloseBtnClick);
      if (Cookies.get(COOKIE_KEY) !== YES_VALUE) {
        setTimeout(() => {
          this.open();
        }, 0);
      }
    },
    destroy() {
      this.$closeBtn.removeEventListener('click', this.onCloseBtnClick);
    },
  }
);

export default cookienotice;
